<template>
    <Content v-if="quiz">
        <LoadingApp :isLoading.sync="isLoading" :is_full_page="true" />
        <img
            v-if="quiz.path_image"
            :src="quiz.path_image"
            :alt="`Questionário: ${quiz.name}`"
        />
        <div class="container content-quiz">
            <primary-title>{{ quiz.name }}</primary-title>
            <QuestionsCategories />
        </div>
    </Content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CPrimaryTitle } from "../../../components/Styles/Components/styled";
import { swall } from "../../../services/sweetAlert";
import { Content } from "./style";
import LoadingApp from "../../../components/LoadingApp.vue";
import QuestionsCategories from "../QuestionsCategories";

export default {
    name: "QuizPage",
    props: {
        quiz_slug: {
            required: true
        }
    },
    components: {
        "primary-title": CPrimaryTitle,
        Content,
        LoadingApp,
        QuestionsCategories
    },
    data() {
        return {
            isLoading: false
        };
    },
    mounted() {
        this.getQuiz();
    },
    methods: {
        ...mapActions("quizzes", ["ActionGetQuiz", "setQuiz"]),
        getQuiz() {
            this.isLoading = true;

            this.ActionGetQuiz(this.quiz_slug)
                .then(response => {
                    this.isLoading = false;
                    this.setQuiz(response.data);
                })
                .catch(error => {
                    this.isLoading = false;
                    swall(error?.msg ?? error?.message ?? error);
                });
        }
    },
    computed: {
        ...mapState("quizzes", ["quiz"])
    }
};
</script>
